import React from 'react'
// import classNames from 'classnames'

// import styles from '../component-styles/counter.module.scss'
import Modal, { ModalHead, ModalBody, ModalFooter } from './modal'
import Heading from './heading'
import ConfirmationButtons from './confirmation-buttons'

interface Props {
  children: React.ReactNode
  title: string
  onToggle: () => void
}

export default function InfoModal({
  children,
  title,
  onToggle,
}: Props): React.ReactElement {
  return (
    <Modal
      active
      toggleActive={() => {
        onToggle()
      }}
      type="white"
      narrow
    >
      <ModalHead>
        <Heading type={3} align="left">
          {title}
        </Heading>
      </ModalHead>
      <ModalBody>{children}</ModalBody>
      <ModalFooter>
        <ConfirmationButtons
          centerAlign
          type="simple"
          onYes={(): void => {
            onToggle()
          }}
          yesLabel="OK"
        />
      </ModalFooter>
    </Modal>
  )
}
